<template>
    <v-row class="wrapper">
        <v-col
            v-show="form.ID_SOL_PAGAMENTO"
            sm="12"
            md="8"
            offset-md="2"
        >
            <v-card>
                <v-card-title class="primary--text">
                    SOLICITAÇÃO DE PAGAMENTO DE DEVOLUÇÃO
                </v-card-title>
                <v-card-text>
                    <v-form
                        ref="form"
                        @submit.prevent="enviarSolicitacao"
                    >
                        <v-row>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.ID_SOL_PAGAMENTO"
                                    filled
                                    readonly
                                    label="ID"
                                />
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.CREATED_AT ? new Date(form.CREATED_AT).toLocaleString() : ''"
                                    filled
                                    readonly
                                    label="CRIADA EM"
                                />
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.UPDATED_AT ? new Date(form.UPDATED_AT).toLocaleString() : ''"
                                    filled
                                    readonly
                                    label="ATUALIZADA EM"
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col
                                cols="4"
                                class="py-0"
                            >
                                <v-text-field
                                    :value="form.CNPJ"
                                    filled
                                    readonly
                                    label="CNPJ"
                                />
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.RAZAO_SOCIAL"
                                    filled
                                    readonly
                                    label="RAZÃO SOCIAL"
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col
                                cols="4"
                                class="py-0"
                            >
                                <v-text-field
                                    :value="form.NOTA_FISCAL"
                                    filled
                                    readonly
                                    label="NOTA FISCAL"
                                />
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.NOTA_FISCAL_SERIE"
                                    filled
                                    readonly
                                    label="NOTA FISCAL - SÉRIE"
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col
                                cols="4"
                                class="py-0"
                            >
                                <v-text-field
                                    :value="form.DATA_EMISSAO"
                                    filled
                                    readonly
                                    label="DATA DE EMISSÃO"
                                />
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.VALOR"
                                    filled
                                    readonly
                                    label="VALOR"
                                    prefix="R$"
                                />
                            </v-col>
                        </v-row>

                        <v-text-field
                            :value="form.CONTATO"
                            filled
                            readonly
                            label="CONTATO"
                        />

                        <v-row>
                            <v-col
                                cols="4"
                                class="py-0"
                            >
                                <v-text-field
                                    :value="form.TELEFONE"
                                    filled
                                    readonly
                                    label="TELEFONE"
                                />
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.EMAIL"
                                    filled
                                    readonly
                                    label="E-MAIL"
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.BANCO"
                                    filled
                                    readonly
                                    label="BANCO"
                                />
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.AGENCIA"
                                    filled
                                    readonly
                                    label="AGÊNCIA"
                                />
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.CONTA_CORRENTE"
                                    filled
                                    readonly
                                    label="CONTA CORRENTE"
                                />
                            </v-col>
                        </v-row>

                        <v-select
                            v-model="form.ID_STATUS_SOLICITACAO"
                            :items="statusList"
                            item-value="ID_STATUS_SOLICITACAO"
                            item-text="NOME"
                            outlined
                            label="STATUS"
                        />

                        <v-textarea
                            v-model="form.OBSERVACAO"
                            outlined
                            label="OBSERVAÇÃO"
                            placeholder="digite uma observação para o atendimento"
                            rows="3"
                            maxlength="500"
                            counter
                        />

                        <v-layout justify-space-between>
                            <div>
                                <v-btn
                                    large
                                    text
                                    color="primary"
                                    @click="() => printDocument()"
                                >
                                    <v-icon left>
                                        mdi-printer
                                    </v-icon>
                                    Imprimir
                                </v-btn>
                                <v-btn
                                    large
                                    text
                                    color="primary"
                                    :href="fileDownloadLink"
                                >
                                    <v-icon left>
                                        mdi-file-download-outline
                                    </v-icon>
                                    Baixar anexo
                                </v-btn>
                            </div>

                            <v-btn
                                large
                                color="primary"
                                @click="atualizarSolicitacao"
                            >
                                <v-icon left>
                                    mdi-check
                                </v-icon>
                                Atualizar Solicitação
                            </v-btn>
                        </v-layout>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import api from '../../../services/api';

    export default {
        data() {
            return {
                form: {
                    ID_SOL_PAGAMENTO: null,
                    CREATED_AT: null,
                    CNPJ: null,
                    RAZAO_SOCIAL: null,
                    NOTA_FISCAL: null,
                    NOTA_FISCAL_SERIE: null,
                    DATA_EMISSAO: null,
                    VALOR: null,
                    CONTATO: null,
                    TELEFONE: null,
                    EMAIL: null,
                    BANCO: null,
                    AGENCIA: null,
                    CONTA_CORRENTE: null,
                    FILE_NFD: null,
                    ID_STATUS_SOLICITACAO: null,
                    OBSERVACAO: null
                },

                statusList: []
            };
        },

        computed: {
            fileDownloadLink() {
                const folder = this.$root.config.NFD_UPLOAD_FOLDER;
                const filename = this.form.FILE_NFD;
                const userData = localStorage.getItem('USER') && JSON.parse(localStorage.getItem('USER'));

                if (folder && filename && userData) {
                    return `${this.$root.config.API_URL}/admin/files?folder=${folder}&filename=${filename}&token=${userData.TOKEN}`;
                }

                return null;
            }
        },

        created() {
            this.fetchSolicitacao();
            this.fetchStatusList();
        },

        methods: {
            async fetchSolicitacao() {
                try {
                    const response = await api.getSolPagamentoByID(this.$route.params.id);

                    this.form = response.data;
                } catch (error) {
                    if (error.response && error.response.status === 404) {
                        this.$router.push('/painel-solpagamento');
                    }
                }
            },

            async fetchStatusList() {
                try {
                    const response = await api.getStatusSolicitacao();

                    this.statusList = response.data;
                } catch (error) {}
            },

            async atualizarSolicitacao() {
                try {
                    await api.updateSolPagamento(this.form.ID_SOL_PAGAMENTO, this.form);

                    await this.fetchSolicitacao();

                    this.$root.$emit('message', { text: 'Solicitação atualizada com sucesso!', color: 'success' });
                } catch (error) {
                    this.$root.$emit('message', { text: 'Erro ao atualizar a solicitação.', color: 'error' });
                }
            },

            printDocument() {
                window.print();
            }
        }
    };
</script>